let stripe;
let elements;
let cardElement;

export default config => ({
  stripeValidationError: "",
  paymentError: "",
  stripeInitialized: false,
  processing: false,
  cardHolderName: config.cardHolderName,
  init() {
    try {
      if (typeof Stripe !== 'undefined') {
        this.setupStripe();
      } else {
        const waitForStripe = setInterval(() => {
          if (typeof Stripe !== 'undefined') {
            clearInterval(waitForStripe);
            this.setupStripe();
          }
        }, 100)
      }

    } catch (err) {
      // Stripe could not be initialized.
      console.log(err);
      this.stripeError = true;
    }
  },
  async processCard() {
    if (this.processing) {
      return;
    }

    this.processing = true;
    const result = await stripe.confirmSetup({
      elements,
      confirmParams: {
        return_url: config.returnUrl
      },
      redirect: "if_required"
    });
    if (result.error) {
      this.stripeError = true;
      if (result.error.type !== "validation_error") {
        this.stripeValidationError = result.error.message;
      } else {
        this.stripeValidationError = "";
      }
      this.processing = false;
    } else {
      if (!result.setupIntent || result.setupIntent.status !== "succeeded") {
        this.paymentError =
          result.setupIntent && result.setupIntent.last_setup_error
            ? result.paymentIntent.last_setup_error
            : "We were unable to process your payment, please contact hello@castos.com for help.";
      }

      this.$wire
        .call(config.submitMethod, result.setupIntent.id)
        .finally(() => {
          this.processing = false;
        });
    }
  },
  setupStripe() {
    if (
      !config ||
      !config.submitMethod ||
      !config.stripePublicKey ||
      !config.stripeClientSecret ||
      !config.returnUrl
    ) {
      throw new Error("Stripe could not be initialized.");
    }
    if (this.stripeInitialized) {
      return;
    }

    stripe = new Stripe(config.stripePublicKey);
    return new Promise((resolve, reject) => {
      this.processing = true;
      const options = {
        clientSecret: config.stripeClientSecret,
        appearance: {
          variables: {
            colorBackground: '#F1F5F9'
          }
        },
      };
      elements = stripe.elements(options);
      cardElement = elements.create("payment");
      cardElement.mount("#payment-element");
      this.processing = false;
      this.stripeInitialized = true;
      resolve();
    });
  }
});
